<template>
  <el-table-column
    prop="order_numbers"
    label="Rendelési számok"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <span>{{ scope.row.order_numbers || '-' }}</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'order_numbers',
  };
</script>
